import { AppThunk } from '../../../reducers';
import { setCurrentDivisionSettings } from '../../../reducers/app/currentDivision';
import { DivisionSetting } from '../../../../common/model/client/divisionType';

export const setDivisionSettings = (settings: DivisionSetting): AppThunk => (dispatch) => {
    dispatch(setCurrentDivisionSettings(settings));
};
